import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";

@Pipe({
  name: "filterShiftsBefore"
})
export class FilterShiftsBeforePipe implements PipeTransform {
  transform(allShifts: NsEmpWebExpData.IShiftData[], min: number, shifts?: any): NsEmpWebExpData.IShiftData[] {
    if (min === undefined || shifts === "Check-In") return allShifts;
    return allShifts.filter(shift => shift.timeInMinutes > min || shift.type === "LEGEND");
  }
}
